import { ChangeEvent, forwardRef, Ref, RefObject } from "react";

interface BaseEquationEditorProps {
  equation: string;
  inline: boolean;
  setEquation: (equation: string) => void;
}

function BaseEquationEditor(
  { equation, setEquation, inline }: BaseEquationEditorProps,
  forwardedRef: Ref<HTMLInputElement | HTMLTextAreaElement>
) {
  const onChange = (event: ChangeEvent) => {
    setEquation((event.target as HTMLInputElement).value);
  };

  return inline ? (
    <span className="border-default bg-content1 inline-flex items-center gap-1 rounded border p-2">
      <span className="text-default-500 text-sm font-medium">$</span>
      <input
        className="border-none bg-transparent p-0 font-mono text-sm outline-none"
        value={equation}
        onChange={onChange}
        autoFocus={true}
        ref={forwardedRef as RefObject<HTMLInputElement>}
      />
      <span className="text-default-500 text-sm font-medium">$</span>
    </span>
  ) : (
    <div className="inline-flex items-center gap-1 rounded border border-gray-200 bg-gray-50 p-2">
      <span className="text-default-500 text-sm font-medium">{"$$\n"}</span>
      <textarea
        className="block min-h-24 w-full resize-y border-none bg-transparent p-2 font-mono text-sm outline-none"
        value={equation}
        onChange={onChange}
        ref={forwardedRef as RefObject<HTMLTextAreaElement>}
      />
      <span className="text-default-500 text-sm font-medium">{"\n$$"}</span>
    </div>
  );
}

export const KatexEquationEditor = forwardRef(BaseEquationEditor);
